import { FormattedMessage } from 'react-intl';

import { FULFILLMENTS_RETURNS_VIEW_ID, FULFILLMENTS_VIEW_ID } from './view-id-constants';
import { SHIPMENTS_FULFILLMENTS_RETURNS_PATH } from '../../../routes/constants';

export const FulfillmentsReturns = {
  label: (
    <FormattedMessage defaultMessage='Returns' description='shipping page left navigation item for fulfillments returns' id='6DbNrn' />
  ),

  expandedDescription: (
    <FormattedMessage defaultMessage='Fulfillments / Returns' description='shipments page grid header, fulfillments.returns' id='CMwrQK' />
  ),

  id: FULFILLMENTS_RETURNS_VIEW_ID,
  navigationOverride: SHIPMENTS_FULFILLMENTS_RETURNS_PATH,
  parentId: FULFILLMENTS_VIEW_ID,
};
